export default __webpack_public_path__ + "static/media/rp3-racing-logo-square.e37f0b29.svg";